import { Box, Icon, Typography } from '@mui/material'

import { React, useState } from 'react'
import AdxFormModal from 'components/reusable/modal/AdxFormModal'
import AdxButton from 'components/custom/AdxButton'

const LearnMoreModal = () => {
  const [modalState, setModalState] = useState(false)

  const handleOpen = () => {
    setModalState(true)
  }

  const handleClose = () => {
    setModalState(false)
  }

  return (
    <>
      <Typography
        onClick={handleOpen}
        variant="body2"
        sx={{
          cursor: 'pointer',

          textDecoration: 'underline',
          color: 'alternate.main',
        }}
      >
        Learn More
      </Typography>
      <AdxFormModal
        title="About Leave Balance Template"
        subtitle=""
        icon={<Icon>info</Icon>}
        iconColor="info.main"
        open={modalState}
        onClose={handleClose}
        handleClose={handleClose}
        handleAction={() => alert('Action button pressed')}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Typography variant="subtitle1">
            The template file will extract all employees data during the initial set up.
          </Typography>
          <Typography variant="subtitle1">
            You will need to fill up the allocation and balance column only for each users. The
            leave policies extracted are depending on the policies that you have created.
          </Typography>
          <Typography variant="subtitle1">
            {'('}Note: All default policies must be turned on before downloading the template. {')'}
          </Typography>
          <AdxButton fullWidth onClick={handleClose}>
            Back
          </AdxButton>
        </Box>
      </AdxFormModal>
    </>
  )
}

export default LearnMoreModal
